import functions from './functions.js';
import Slider from './Slider.js';
import {SimpleGuests, SimpleGuestsDefaults} from "./simple-guests.js";
import {FormGuide, FormGuideDefaults} from "./form-guide.js";
import lozad from 'lozad';

SimpleGuestsDefaults.infantsAge = 6;

$(function() {

    const language = functions.getLang();

    // ? $('#navbarTogglerMain').removeClass('navbar-dark').addClass('visible navbar-light')
    //         : $('#navbarTogglerMain').removeClass('visible navbar-light').addClass('navbar-dark');

    $('body').on('click', '.dropdown-menu', e => {
        e.stopPropagation();
    });

    if ($('.send-page-conversion').length) 
    {
        gtag('event', 'conversion', {'send_to': 'AW-11377319337/Y8OWCL7J_e8YEKm7kLEq'});
    }

    if ($('.send-buy-conversion').length) 
    {
        let transaction_id = +$('.send-buy-conversion').attr('data-id') || 0;
       
        gtag('event', 'conversion', {
            'send_to': 'AW-11377319337/6eoDCIuQtpEZEKm7kLEq',
            'transaction_id': transaction_id
        });
    }

    // if ($('.body-type-details.hs-trip').length) $('.jgl-logo').remove();

    // global datepicker init with automatic "dateTo" set if provided
    let displayDate = new Date('2019-06-01');
    let now = functions.cleanDate(new Date);
    if ( now > displayDate ) {
        displayDate = now;
    }

    $('.datepicker').each((i, elem) => {
        const $datepicker = $(elem);
        console.log($datepicker);
        const minDate = $datepicker.attr('data-min');
        const maxDate = $datepicker.attr('data-max');
        $datepicker.flatpickr({
            altFormat: "j.m.Y",
            dateFormat: "Y-m-d",

            maxDate: maxDate ? maxDate : null,
        });
        // to style clear toggler
        // $datepicker.on('change', e => requestAnimationFrame(() => $(e.target).parent().toggleClass('datepicker-value', !!e.target.value)));
    }); 

    let $navMenu = $('#navbarTogglerMain');

    if ($navMenu.length)
    {
        let $links = $navMenu.find('.nav-link[href^="#"]');
        $links.on('click', function(e) {
            $('#navbarText').collapse('hide');
        })
    }

    function count($this, num) {
        var current = parseInt($this.html(), 10);
        current += num;
        $this.html(current);
        if (current > $this.attr('data-count')) {
            $this.html($this.attr('data-count'));
        }
        else {
            setTimeout(function () { count($this, num) }, 60);
        }
    }

    window.countobserver = lozad('.countable-wrapper', {
        rootMargin: '-150px 0px',
        loaded: el => {
            $(".totalcustomers").each(function () {
                // parse with a base 10 and save to a data atr
                var totalcustomers = $('.totalcustomers').attr('data-totalcustomers');
                $(this).attr('data-count', parseInt(totalcustomers, 10));
                $(this).html('0');
                count($(this), 1000);
            });
    
            $(".totalskikm").each(function () {
                // parse with a base 10 and save to a data atr
                var totalcustomers = $('.totalskikm').attr('data-totalskikm');
                $(this).attr('data-count', parseInt(totalcustomers, 10));
                $(this).html('0');
                count($(this), 133);
            });
    
            $(".totalski").each(function () {
                // parse with a base 10 and save to a data atr
                var totalcustomers = $('.totalski').attr('data-totalski');
                $(this).attr('data-count', parseInt(totalcustomers, 10));
                $(this).html('0');
                count($(this), 1);
            });
        }
    });
    window.countobserver.observe();

    // window.animateobserver = lozad('.animate-text', {
    //     rootMargin: '-100px 20000px',
    //     loaded: el => {
    //         $(el).addClass('trigger');
    //     }
    // });
    // window.animateobserver.observe();

    // window.animateobserver = lozad('.animate-text-right', {
    //     rootMargin: '-100px 20000px',
    //     loaded: el => {
    //         $(el).addClass('trigger');
    //     }
    // });
    // window.animateobserver.observe();
    



    $('.simple-guests').each((i, elem) => {
		elem._simpleGuests = new SimpleGuests(elem);
	});

    $('.form-guide').each((i, elem) => {
		new FormGuide(elem);
	});


    $($('#pills-tab').find('.nav-link')[0]).addClass('active');
    $($('#pills-tabContent').find('.tab-pane')[0]).addClass('show active');
   



    /* gallery */
    const lg = {};
    window.showGallery = (index, id) => {
        index = +index || 0;
        if ( lg[id] ) {
            lg[id].index = index;
            lg[id].build(index);
        } else {
            let $elem = $('[data-images-' + id + ']');
            lg[id] = $elem.lightGallery({
                dynamic: true,
                thumbnail: true,
                toogleThumb: false,
                thumbWidth: 130,
                thumbMargin: 10,
                download: false,
                preload: 2,
                index: index,
                dynamicEl: JSON.parse($elem.attr('data-images-' + id))
            }).data('lightGallery');
        }
    };
    $('[data-gallery-id]').on('click', function (e) {
        e.preventDefault();
        let galleryId = $(this).attr('data-gallery-id');
        galleryId && showGallery($(this).attr('data-index'), galleryId);
    });
    // don't focus div with gallery
    $('[data-gallery-id]').on('focus', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        return false;
    });

    
    // menu links active
    const path = location.pathname.replace(/\/$/, '');
    $('.main-header [href], footer [href]').each((i, link) => {
        let href = link.getAttribute('href');
        if ( href && href != '#' ) {
            href = href.split('?')[0].replace(/\/$/, '');
            if ( path === href ) {
                $(link).addClass('active').closest('.nav-item').addClass('active');
            }
        }
    });

    // global tooltip init
    //('[data-toggle="tooltip"]').tooltip();

    // mobile menu handling
    (() => {
        const $header = $('.main-header');
        const $collapser = $('#main-menu');

        // ensure navbar toggler also open closes main-menu
        $collapser
            .on('show.bs.collapse', () => {
                document.body.classList.add('modal-transition');
                document.body.classList.add('modal-active');
            })
            .on('hide.bs.collapse', () => {
                document.body.classList.remove('modal-active');
            })
            .on('hidden.bs.collapse', () => {
                document.body.classList.remove('modal-transition');
            });

        // click on "overlay" closes menu
        $header.find('.header-overlay').on('click', () => {
            $collapser.collapse('hide');
        });
    })();

    // scrool to element handling
    $(document).on('click', '[data-scroll-to]', e => {
        e.preventDefault();
        const $this = $(e.target);
        let scrollTo = $this.attr('data-scroll-to').split(',');
        functions.scrollToElement(scrollTo[0], scrollTo[1] || 0);
    });
    


    // select2 templates can be defined as data-template="destinations" ...
    const selectTemplates = {
        destinations: data => {
            if ( !data.element ) {
                return data.text;
            }
            if(data.placeId && data.placeName) {
                //const $element = $(data.element).addClass(data.element.className).text(data.placeName);
                const $element = $('<span>').addClass(data.element.className).text(data.placeName);
                return $element;
            }
            if(data.text) {
                const $element = $('<span>').addClass(data.element.className).text(data.text);
                let elemClass;
                switch ( (data.dest).split(':').length ) {
                    case 1: elemClass = 'ps-1 fw-bold'; break;
                    case 2: elemClass = 'ps-3 fw-bold'; break;
                    case 3: elemClass = 'ps-5 '; break;
                    case 4: elemClass = 'ps-5 '; break;
                    default: elemClass = 'h5'; break;
                }
                $element.addClass(elemClass);
                return $element;
            }
        },
    };

    // global init select2
    // data-templates
    // data-data
    // data-allow-clear
    // data-nosearch
    // placeholder
    $.map($('.select2'), elem => {
        const $elem = $(elem);
        const config = { dropdownParent: $elem.parent(), language: language };
        config.allowClear = $elem.attr('data-allow-clear');

        // find select2 which has an attribute data-data
        const data = $elem.attr('data-data');
        if ( data ) {
            try {
                config.data = JSON.parse(data);
            } catch (e) {}
        } 
        else if ( $elem.attr('data-special') ) {
            let newData = $('body').attr('data-select-' + $elem.attr('data-special'));
            config.data = JSON.parse(newData);
        }

        if ( $elem.attr('data-template') ) {
            config.templateResult = selectTemplates[$elem.attr('data-template')];
        }
        if ( $elem.attr('data-template-selection') ) {
            config.templateSelection = selectTemplates[$elem.attr('data-template-selection')];
        }

        if ( $elem.attr('data-nosearch') !== undefined ) {
            config.minimumResultsForSearch = Infinity;
        }

        let placeholder = $elem.attr('placeholder');
        $elem.removeAttr('placeholder');
        config.placeholder = placeholder || ' ';
        
        $elem.select2(config)
            .on('select2:clear', () => {
                $elem[0].cleared = true;
            })
            .on('select2:opening', e => {
                if ( $elem[0].cleared ) {
                    e.preventDefault();
                    $elem[0].cleared = false;
                }
            });
    });
    
    // advanced form controls
    // input-popover
    $('body').on('click', '.dropdown-menu-popover', e => {
        e.stopPropagation();
    });



    $('.nav-collapse').on('click', function(e) {
        let $target = $(this);
        $target.parent().toggleClass('collapse-active', ! $target.hasClass('collapsed'));
    })


   

    function dateDiff(from, to) {
        let f = Date.UTC(from.getFullYear(), from.getMonth()+1, from.getDate());
        let t = Date.UTC(to.getFullYear(), to.getMonth()+1, to.getDate());
    
        return Math.round((from - to) / (1000 * 60 * 60 * 24));
    }
    
});


